import { useRef, useEffect } from 'react'

const usePortal = (elementId = 'root', className) => {
	const portal = useRef()
	if(!portal.current) {
		portal.current = document.createElement('div')
		if(className) {
			portal.current.className = className
		}
	}
	useEffect(() => {
		if(portal.current && className && className !== portal.current.className) {
			portal.current.className = className
		}
	}, [className])
	useEffect(() => {
		const appRoot = document.getElementById(elementId)
		appRoot.appendChild(portal.current)
		return () => {
			// Catch errors Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
			try {
				appRoot.removeChild(portal.current)
			} catch(e) {
				//
			}
		}
	}, [elementId])
	return portal.current
}

export default usePortal
